import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'sharedWebpack/Amount';
import ExchangeCartRouteTitle from '../ExchangeCartRouteTitle';
import './styles.scss';

const ExchangeAccordionContent = ({ price, trips }) => (
  <div className="exchange-accordion-content d-flex align-center justify-between">
    <ExchangeCartRouteTitle trips={trips} />
    <Amount currency={price.currency} value={price.amount} />
  </div>
);

ExchangeAccordionContent.propTypes = {
  price: PropTypes.shape({
    currency: PropTypes.string,
    amount: PropTypes.string,
  }).isRequired,
  trips: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ExchangeAccordionContent;
